/* 메뉴 정보  */
// 초기 설정
const INITIAL_SETTING = {
  id: 'basic',
  children: {
    // 2depth
    DEVICE_REGISTRATION: {
      id: 'deviceRegistration',
      children: {
        // 3depth
        NETWORK: {
          id: 'WNetwork',
        },
        SERVER: {
          id: 'WServer',
        },
      },
    },
  },
};

const menuInfo = {
  INITIAL_SETTING,
};

/* 메뉴 이동 CONST  */
// 모델링
const MODELING = [menuInfo.INITIAL_SETTING, menuInfo.INITIAL_SETTING.children.DEVICE_REGISTRATION, menuInfo.INITIAL_SETTING.children.DEVICE_REGISTRATION.children.NETWORK];
// 자동화 모델링
const AMS_MODELING = [menuInfo.INITIAL_SETTING, menuInfo.INITIAL_SETTING.children.DEVICE_REGISTRATION, menuInfo.INITIAL_SETTING.children.DEVICE_REGISTRATION.children.SERVER];

export default {
  menuInfo,
  autoMoveMenuConst: {
    MODELING,
    AMS_MODELING,
  },
};



// WEBPACK FOOTER //
// ./src/constants/setting.js